import { Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

export interface InfoPopupData {
  title: string;
  text: string;
}

// redesigned, public-only counterpart of the lib InfoPopupComponent
// (customer-app still opens the lib one)
@Component({
  selector: 'app-info-popup',
  templateUrl: './info-popup.component.html',
  styleUrls: ['./info-popup.component.scss'],
  standalone: false,
})
export class InfoPopupComponent {
  readonly data: InfoPopupData = inject(MAT_DIALOG_DATA);
  private readonly dialogRef = inject(MatDialogRef<InfoPopupComponent>);

  constructor() {
    inject(Router)
      .events.pipe(
        filter((e) => e instanceof NavigationEnd),
        takeUntilDestroyed()
      )
      .subscribe(() => this.dialogRef.close());
  }
}
